<template>
  <div>
<!--    <vue-json-pretty-->
<!--      :path="'res'"-->
<!--      :data="$store.state.admin.status">-->
<!--    </vue-json-pretty>-->
    <h4 is="sui-header">Last Contact from any device</h4>
    {{getLastContact | formatTime}} ({{getLastContact | formatDifference}} ago)
    <sui-divider />
    <div>
      <h4 is="sui-header">Stats last Week</h4>
      <locaite-stats />
    </div>
    <sui-divider />
    <h4 is="sui-header">Connected Devices</h4>
    <locaite-status-connected-devices v-if="$store.state.admin.status" :data="$store.state.admin.status.deviceConnections"></locaite-status-connected-devices>
    <sui-divider />
    <sui-button @click="$store.dispatch('admin/getStatus')">Refresh</sui-button>
    <h4 is="sui-header">Misc</h4>
    <div>
      <sui-button @click="$store.dispatch('admin/flushCache', true)">Flush / Reload Cache</sui-button>
      <sui-button @click="$store.dispatch('admin/magicButton')">Magic Button (for Marek)</sui-button>
    </div>
  </div>
</template>

<script>
  // import VueJsonPretty from 'vue-json-pretty'
  import moment from 'moment'
  import LocaiteStatusConnectedDevices from "./LocaiteStatusConnectedDevices";
  import LocaiteStats from "./LocaiteStats";
    export default {
      name: "LocaiteStatus",
      components: {LocaiteStats, LocaiteStatusConnectedDevices},
      async mounted() {
        await this.$store.dispatch('admin/getStatus')
      },
      methods: {
      },
      computed: {
        getLastContact() {
          if (!this.$store.state.admin.status) {
            return ""
          }
          let connections = this.$store.state.admin.status.deviceConnections || {}
          let lastContact
          for (let index in connections) {
            let item = connections[index]
            if (!lastContact || moment(item.LastContact).isAfter(lastContact)) {
              lastContact = moment(item.LastContact)
            }
          }
          return lastContact
        }
      }
    }
</script>

<style scoped lang="less">


</style>
